// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"281":"6efaf255","413":"4a1fbeb2","613":"231b1ac7"}[chunkId] + ".chunk.css";
};